<mat-card
  class="unit-card-container"
  (click)="navigateToDayItem(gradeUnitDay.dayNumber)"
  (keydown.enter)="navigateToDayItem(gradeUnitDay.dayNumber)"
>
  <div class="cover-image">
    <img
      [src]="gradeUnitDay.dayCoverImageUrl"
      [alt]="getAltText(gradeUnitDay.dayNumber)"
      tabindex="0"
    />
  </div>
  <div class="unit-title header-text" [matTooltip]="gradeUnitDay.dayTitle">
    Day {{ gradeUnitDay.dayNumber }}:
    {{ gradeUnitDay.dayTitle | truncateText: 20 }}
  </div>
  <ng-container *ngIf="checkPermission.isSuperAdmin">
    <div
      class="unit-status-container header-text"
      [ngClass]="checkStatus(gradeUnitDay.status)"
    >
      {{ pageDetails | uppercase }}
      <div class="status">
        <ng-container [ngSwitch]="gradeUnitDay.status">
          <ng-container *ngSwitchCase="statusEnum.PENDING">
            {{ 'Work in Progress' | uppercase }}
          </ng-container>
          <ng-container *ngSwitchCase="statusEnum.READY">
            {{ 'Ready' | uppercase }}
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</mat-card>
